export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapConnectedVehicles';
export const ENTITY_EDIT_ROUTE = 'connectedvehicles/details';
